export default {"src":"/_next/static/media/finance-options-icon.1baddebf.svg","height":49,"width":43};